export default "__VITE_ASSET__Dii4m5zg__"